import React from "react";

const ShowDiploma = ({ r }) => {
  const { institutionName, yearOfGraduation, classification, courseOfStudy, cgpa, diplomaType } = r?.results;
  return (
    <>
      <div className="row my-2">
        <div className="col-md-4">Institution</div>
        <div className="col-md-8">{institutionName}</div>
      </div>
      <div className="row my-2">
        <div className="col-md-4">Graduation Year</div>
        <div className="col-md-8">{yearOfGraduation}</div>
      </div>
      <div className="row my-2">
        <div className="col-md-4">Course</div>
        <div className="col-md-8">
          {diplomaType} {courseOfStudy}
        </div>
      </div>
      <div className="row my-2">
        <div className="col-md-4">Classification</div>
        <div className="col-md-8">{classification}</div>
      </div>
      <div className="row my-2">
        <div className="col-md-4">CGPA</div>
        <div className="col-md-8">{cgpa}</div>
      </div>
    </>
  );
};

export default ShowDiploma;
